import Login from "@/modules/auth/components/Login";

export default [
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
];



// WEBPACK FOOTER //
// ./src/modules/auth/router/auth.js